<tf-tag-editor
  [tags]="selectedTags()"
  [availableTags]="availableTags()"
  [editable]="true"
  [canCreate]="canCreate()"
  (tagsChange)="onTagsChange($event)"
  (tagCreate)="onCreateRequested($event)"
  (searchOpened)="onSearchOpened()" />
